(ns frontend.ui.ai-summary-configuration.upload
  "Shared tenant attachment upload effect for summary configuration inputs."
  (:require
   [frontend.actions.attachment :as attachment-actions]
   [frontend.actions.common :as common-actions]
   [oops.core :as oops]
   [re-frame.core :as rf]))

(defn document-multipart-params
  "Build multipart parameters for a tenant-scoped configuration document.
   These uploads are intentionally unattached until a configuration references
   them, so the optional attachment target must be omitted from the request."
  [{:keys [file filename token]}]
  {:filename filename
   :file file
   :token token})

(defn uploaded-attachment
  "Extract the attachment entity returned by the legacy upload API. The shared
   action passes the decoded API payload, whose established shape is
   `{:body {:db/id ...}}`; accepting an already-unwrapped entity keeps this
   boundary tolerant of direct test and future adapter calls."
  [response]
  (let [attachment (or (:body response) response)]
    (when (:db/id attachment)
      attachment)))

(rf/reg-fx
 ::document
 (fn [{:keys [file on-success on-error]}]
   (let [filename (oops/oget file "name")
         upload! (fn [token]
                   (attachment-actions/*=>add-attachment
                    {:multipart-params (document-multipart-params
                                        {:filename filename
                                         :file file
                                         :token token})
                     :progress (fn [_progress] nil)}
                    (fn [response]
                      (if-let [attachment (uploaded-attachment response)]
                        (rf/dispatch (conj on-success attachment))
                        (rf/dispatch
                         (conj on-error
                               {:error :invalid-upload-response}))))
                    (fn [error]
                      (rf/dispatch (conj on-error error)))))]
     (common-actions/*<-create-op-token
      nil
      upload!
      (fn [error]
        (rf/dispatch (conj on-error error)))))))
